import { render, staticRenderFns } from "./BrandLogo.vue?vue&type=template&id=4161b967"
import script from "./BrandLogo.vue?vue&type=script&lang=js"
export * from "./BrandLogo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports